import { useCase as spider } from './spider';
import { useCase as COCs } from './COCs';
import { useCase as classificationML } from './classificationML';
import { UseCaseWrapperType } from '../../../../Types/Portfolio/UseCaseWrapperType';

export const useCases: UseCaseWrapperType[] = [
	{
		id: 'bambaCOCs',
		section: 'Bamba',
		content: COCs,
		tags: ['agility'],
	},
	{
		id: 'spider',
		section: 'Bamba',
		content: spider,
		tags: ['agility'],
	},

	{
		id: 'classificationML',
		section: 'Bamba',
		content: classificationML,
		tags: ['agility', 'AI', 'ML'],
	},
];
